import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearSetupType, selectCategory, selectIsShowOption, selectSetupTypeUpdate, selectSetupUpdateId, setCategory, setIsShowOption } from '../../../features/setup/setupSlice'
import { useMutationData } from '../../../hooks/api/useMutationData'
import { CloseIcon } from '../../../assets/icons/Svg'
import Label from '../../ui/Label'
import Input from '../../ui/Input'
import DropdownBtn from '../../ui/DropdownBtn'
import { CreateNewCategory, UpdateCategory } from '../../../features/setup/setupRequestBody'
import { showToast } from '../../../toastify/Toast'
import { handleApiError } from '../../../utils/handleApiError'
import Textarea from '../../ui/Textarea'
import { statusList } from '../../../constant/default'

export default function Categories() {

    const dispatch = useDispatch()
    const setupTypeUpdate = useSelector(selectSetupTypeUpdate)
    const typeId = useSelector(selectSetupUpdateId)
    const isShow = useSelector(selectIsShowOption)
    const category = useSelector(selectCategory)
    const {
        createCategory,
        isLoadingCreateCategory,

        updateCategory,
        isLoadingUpdateCategory,
    } = useMutationData();
    const isUpdateAddons = setupTypeUpdate === 'setUpCategoryUpdate'
    const headerTitle = isUpdateAddons ? 'Update category' : 'Add new category'
    const isComplete = !category.categoryName || (isUpdateAddons && category.isActive === undefined)
    const isLoading = isLoadingCreateCategory || isLoadingUpdateCategory
    const isDisable = isComplete|| isLoading
    const temperatureStatus =
        category.isActive === undefined
        ? "Select status"
            : category.isActive
        ? "Active"
            : "Inactive";
    const btnTitle = isLoading ? 
        isUpdateAddons
            ? "Updating..."
            : "Creating..."
        : isUpdateAddons
            ? "Save Update"
            : "Save"

    const handleAddons = async () => {
        try {
            if(!category.categoryName) return showToast('Category name is required', 'error')

            if(isUpdateAddons) {
                if(!typeId) return showToast('Missing category id', 'error')
                if(category.isActive === undefined) return showToast("Category status required.", "error");

                const body: UpdateCategory = {
                    categoryName: category.categoryName,
                    description: category.description,
                    isActive: category.isActive
                }
                await updateCategory({ categoryId: typeId, body}).unwrap()
                showToast('Category updated successfully', 'success')
            } else {
                const body: CreateNewCategory = {
                    categoryName: category.categoryName,
                    description: category.description 
                }
                await createCategory(body).unwrap()
                showToast('Category created successfully', 'success')
            }
            dispatch(clearSetupType({ category: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))
        } catch (error) {
            handleApiError(error)
        }
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                                    {headerTitle}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => dispatch(clearSetupType({ 
                                        addons: true,
                                        category: true,
                                        temperature: true, 
                                        setupTypeId: true, 
                                        setupType: true, 
                                        setupTypeUpdate: true, 
                                    }))}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Category name *'}/>
                                    <Input
                                        type={'text'}
                                        textSize='text-xs'
                                        value={category.categoryName}
                                        onChange={(e) => dispatch(setCategory({ categoryName: e.target.value }))}
                                        required
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Description'}/>
                                    <Textarea
                                        rowCount={3}
                                        required
                                        value={category.description}
                                        onChange={(e) => dispatch(setCategory({ description: e.target.value }))}
                                        placeholder={''}
                                    />
                                </div>
                            </div>
                            {isUpdateAddons && (
                                <div>
                                    <Label label={'Status *'}/>
                                        <div className='relative inline-block h-auto w-full'>
                                            <div className='w-full h-auto'>
                                                <DropdownBtn
                                                    label={temperatureStatus}
                                                    isOpen={isShow}
                                                    onClick={() => dispatch(setIsShowOption(!isShow))}
                                                    isCustomClass={true}
                                                    disabled={isLoading}
                                                    customClass={'text-xs flex w-full justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                                />
                                                {isShow && (
                                                    <ul className="text-xs absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                                        {statusList.map((stat) => (
                                                            <li
                                                                key={stat.statusId}
                                                                onClick={() => {
                                                                    dispatch(setCategory({ isActive: stat.isActive }) );
                                                                    dispatch(setIsShowOption(false));
                                                                }}
                                                                className='text-xs px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer w-full'
                                                            >
                                                                {stat.status}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                </div>
                            )}
                        </div>
                        <button 
                            onClick={handleAddons}
                            disabled={isDisable}
                            className={`w-full text-xs px-2 py-1.5 rounded font-medium transition-all shadow-md bg-cbColor
                                ${isComplete ? 'cursor-not-allowed bg-gray-200 border text-black' :  !isLoading ? 'text-white' : 'text-white'}
                            `}
                        >
                            {btnTitle}
                        </button> 
                    </div>
                </div>
            </div>
        </div>
    )
}
